import { getProductCollectionsJson } from './helpers';

/**
 * ProductSEO section
 * 
 * This class is responsible for handling the SEO data for the product page.
 * It listens for the `astr-previous-collection` event dispatched from the Breadcrumbs component
 * and initializes the section with the collection data.
 */
export default class ProductSEO {
  collectionData;
  menuData;

  constructor() {
    this.collectionData = null;
    this.menuData = null;

    this.elements = {
      productSEOContainer: document.querySelector('section .product-seo .container'),
    };

    if (this.elements.productSEOContainer) {
      // document.addEventListener('astr-previous-collection', (e) => {
      //   if (typeof e.detail.data === 'undefined' || e.detail.data === null) {
      //     return;
      //   }
  
      //   this.collectionData = e.detail.data;
      //   this.initSection();
      // });

      this.collectionData = this.retrievePreviousCollection();

      if (typeof this.collectionData === 'undefined' || this.collectionData === null) {
        this.collectionData = {
          title: 'Shop All',
          handle: 'shop-all',
        };
      }

      this.initSection();
    }
  }

  /**
   * Retrieve the previous collection from the referrer URL
   * 
   * @returns {object|undefined} The previous collection data
   */
  retrievePreviousCollection = () => {
    try {
      // Validate product collections JSON
      const product_collections_json = getProductCollectionsJson();
      if (!Array.isArray(product_collections_json)) {
        console.warn('[ProductSEO] Invalid product collections JSON.');
        return;
      }

      // Validate referrer
      if (!document.referrer || !document.referrer.includes('/collections/')) {
        console.warn('[ProductSEO] Referrer does not contain a collection.');
        return;
      }

      let previous_collection_handle = '';
      let previous_collection_title = '';

      // window.localStorage.getItem('previous-page')
      const previous_collection_parts = document.referrer.split('/');

      // ["https:", "", "www.astrthelabel.com", ("en-gb"), "collections", "whats-new", ("red")]
      if (previous_collection_parts.length < 5) {
        return;
      }

      previous_collection_handle = previous_collection_parts[previous_collection_parts.indexOf('collections') + 1].split('?')[0];

      const previous_collection = product_collections_json.find((collection) => collection.handle === previous_collection_handle);

      if (typeof previous_collection === 'undefined') {
        return;
      }

      previous_collection_title = previous_collection.title;

      return {
        title: previous_collection_title,
        handle: previous_collection_handle,
      };
    } catch (error) {
      console.error('[ProductSEO] Error in init function:', error);
    }
  };

  /**
   * Pull the collection menu from the collection page
   * 
   * @returns {Promise<boolean>} True if the menu was pulled successfully
   */
  pullCollectionMenu = () => {
    return new Promise((resolve) => {
      try {
        // Wasn't able to use https://shopify.dev/docs/api/ajax/section-rendering
        $.ajax({
          url: `${window.location.origin}/collections/${this.collectionData.handle}`,
          dataType: 'html',
          method: 'get',
        }).done((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const json_element = doc.querySelector('[data-collection-sub-categories-json]');
          let menu_data = (json_element && json_element.textContent.length > 0) ? JSON.parse(json_element.textContent) : [];

          const json_extra_element = doc.querySelector('[data-collection-sub-categories-extra-json]');
          // Add the extra menu items at the end of the main ones
          if (json_extra_element && json_extra_element.textContent.length > 0) {
            const extra_menu_data = JSON.parse(json_extra_element.textContent);
            menu_data = menu_data.concat(extra_menu_data);
          }

          this.menuData = menu_data;

          resolve(true);
        });
      } catch (error) {
        console.log('Cannot load the menu associated to the collection', error);
        resolve(null);
      }
    });
  };

  /**
   * Initialize the section
   * 
   * @returns {Promise<void>}
   */
  initSection = async () => {
    if (!this.collectionData) {
      console.log('[ProductSEO] No collection data found for SEO');
      return;
    }

    await this.pullCollectionMenu();

    if (!this.menuData || this.menuData.length === 0) {
      console.log('[ProductSEO] No menu data found for SEO', this.collectionData);

      if (this.collectionData.handle === 'shop-all') {
        return;
      }

      // Fallback to the shop all collection
      this.collectionData = {
        title: 'Shop All',
        handle: 'shop-all',
      };

      await this.initSection();
      return;
    }

    const pathname_parts = window.location.pathname.split('/'); // ['', ('en-gb'), 'products', 'evetta-top']
    let url_locale = '';
    if (pathname_parts[1] !== 'products') {
      url_locale = `/${pathname_parts[1]}`; // for example: /en-gb
    }

    // ASTR-872 - We now use the title from the 1st bubble
    let collection_title = this.collectionData.title;
    if (this.menuData.length > 0) {
      collection_title = this.menuData[0].title;
    }

    // Remove "All" from the title
    collection_title = collection_title.replace('All', '');

    let seo_html = `
      <h4 class="product-seo__title">
        <a href="${url_locale}/collections/${this.collectionData.handle}">Shop more ${(this.collectionData.handle === 'shop-all') ? '' : collection_title}</a>
      </h4>
      <ul class="product-seo__list">
    `;

    this.menuData.map(item => {
      if (typeof item.url === 'undefined' || item.url === '') {
        return;
      }

      // Add each menu item to the SEO section
      const menu_item_url = `${url_locale}${item.url}`;
      seo_html += `
        <li class="product-seo__item">
          <a href="${menu_item_url}">${item.title}</a>
        </li>`;
    });

    seo_html += `
      </ul>
    `;

    this.elements.productSEOContainer.innerHTML = seo_html;
  };
}
